import React from 'react';
import Navigation from "../components/Navigation";
import Content from "../components/Content";

const SellingAgentLayout = ({user, role, modules}) => {
  /*
      JSX Markup for default layout component includes
      navbar, sidebar, and main content components
     */
  return (
    <div className="d-flex" id="wrapper">
      <div id="view-wrapper">
        <Navigation
          displayName={user.attributes['custom:display_name']}
          email={user.attributes['email']}
          role={role}
          entity={user.attributes['custom:entity_id']}
          modules={modules}/>
        <Content modules={modules} />
      </div>
    </div>
  );
}

export default SellingAgentLayout;
